import { render, staticRenderFns } from "./ProductDocumentItem.vue?vue&type=template&id=55afc600&scoped=true&"
import script from "./ProductDocumentItem.vue?vue&type=script&lang=js&"
export * from "./ProductDocumentItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductDocumentItem.vue?vue&type=style&index=0&id=55afc600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55afc600",
  null
  
)

export default component.exports